"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _debounce = _interopRequireDefault(require("@sd-utility/debounce"));
var _ChevronRight = _interopRequireDefault(require("@tvg/fuse-icons/lib/ChevronRight"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _buttons = require("../../fuse-buttons/src/buttons");
var _picture = require("../../fuse-picture/src/picture");
var _styledContentBanner = require("./styled-content-banner-1");
var _excluded = ["className", "dataAnalyticsId", "dataAnalyticsIdSecondary", "dataTestId", "image", "link", "lLayout", "secondaryLink", "smallVariant", "textContent", "variant"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var defaultProps = {
  className: undefined,
  dataAnalyticsId: undefined,
  dataAnalyticsIdSecondary: undefined,
  dataTestId: undefined,
  image: {
    fallbackSource: undefined,
    isLazy: true,
    sources: {
      srcSet: undefined,
      type: undefined
    },
    size: 'small'
  },
  link: {
    href: undefined,
    onClick: undefined,
    text: undefined
  },
  lLayout: 'v1',
  secondaryLink: {
    href: undefined,
    onClick: undefined,
    text: undefined
  },
  smallVariant: false,
  textContent: {
    addBrandColour: undefined,
    heading: undefined,
    headingTag: 'h2',
    legalText: undefined,
    paragraph: undefined,
    representative: undefined,
    subHeading: undefined,
    subHeadingTag: 'h3',
    switchSubHeadingPosition: false
  },
  variant: 'brandLight'
};
var propTypes = {
  className: _propTypes["default"].string,
  dataAnalyticsId: _propTypes["default"].string,
  dataAnalyticsIdSecondary: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string,
  image: _propTypes["default"].shape({
    sources: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      srcSet: _propTypes["default"].string,
      type: _propTypes["default"].string
    })),
    fallbackSource: _propTypes["default"].string,
    isLazy: _propTypes["default"].bool,
    size: _propTypes["default"].oneOf(['small', 'large'])
  }),
  link: _propTypes["default"].shape({
    href: _propTypes["default"].string,
    onClick: _propTypes["default"].func,
    text: _propTypes["default"].string
  }),
  lLayout: _propTypes["default"].oneOf(['v1', 'v2']),
  secondaryLink: _propTypes["default"].shape({
    href: _propTypes["default"].string,
    onClick: _propTypes["default"].func,
    text: _propTypes["default"].string
  }),
  smallVariant: _propTypes["default"].bool,
  textContent: _propTypes["default"].shape({
    addBrandColour: _propTypes["default"].oneOf(['heading', 'representative', 'subHeading']),
    heading: _propTypes["default"].string,
    headingTag: _propTypes["default"].string,
    legalText: _propTypes["default"].string,
    paragraph: _propTypes["default"].string,
    representative: _propTypes["default"].string,
    subHeading: _propTypes["default"].string,
    subHeadingTag: _propTypes["default"].string,
    switchSubHeadingPosition: _propTypes["default"].bool
  }),
  variant: _propTypes["default"].oneOf(['brandLight', 'brandLightWithBorder', 'whiteWithBorder', 'grey', 'brand', 'black'])
};
function ContentBanner1(_ref) {
  var className = _ref.className,
    dataAnalyticsId = _ref.dataAnalyticsId,
    dataAnalyticsIdSecondary = _ref.dataAnalyticsIdSecondary,
    dataTestId = _ref.dataTestId,
    image = _ref.image,
    link = _ref.link,
    lLayout = _ref.lLayout,
    secondaryLink = _ref.secondaryLink,
    smallVariant = _ref.smallVariant,
    textContent = _ref.textContent,
    variant = _ref.variant,
    props = _objectWithoutProperties(_ref, _excluded);
  var headingTag = textContent.headingTag,
    heading = textContent.heading,
    subHeading = textContent.subHeading,
    subHeadingTag = textContent.subHeadingTag,
    paragraph = textContent.paragraph,
    representative = textContent.representative,
    addBrandColour = textContent.addBrandColour,
    switchSubHeadingPosition = textContent.switchSubHeadingPosition,
    legalText = textContent.legalText;
  var SubHeadingElement = /*#__PURE__*/_react["default"].createElement(_styledContentBanner.StyledSubHeading, {
    size: {
      xxs: smallVariant ? '1' : '3',
      l: '3'
    },
    tag: subHeadingTag,
    type: "heading",
    variant: variant,
    addBrandColour: addBrandColour,
    smallVariant: smallVariant
  }, subHeading);
  var paragraphSize = (0, _react.useMemo)(function () {
    return {
      xxs: '1',
      l: lLayout === 'v1' ? '2' : '1'
    };
  }, [lLayout]);
  var ParagraphElement = /*#__PURE__*/_react["default"].createElement(_styledContentBanner.StyledParagraph, {
    size: paragraphSize,
    tag: "p",
    type: "paragraph",
    variant: variant
  }, paragraph);
  var activePrimaryCTA = link.text && (!!link.href || !!link.onClick);
  var activeSecondaryCTA = secondaryLink.text && (!!secondaryLink.href || !!secondaryLink.onClick);
  var isPrimaryLink = !!link.href;
  var onlyOneCTA = !activeSecondaryCTA;

  // Refs
  var copyWrapperRef = (0, _react.useRef)();
  var buttonsContainerRef = (0, _react.useRef)();
  var primaryButtonRef = (0, _react.useRef)();
  var secondaryButtonRef = (0, _react.useRef)();
  /**
   * Function that sets the layout of the buttons to side by side or stacked depending on the buttons width, gap, container size and viewport
   */
  var setButtonsLayout = (0, _react.useCallback)(function () {
    // Button gap set to initial side by side gap of --spacing-global-space6 = 16px
    var buttonGap = 16;
    var copyWrapperWidth = Math.floor(copyWrapperRef.current.offsetWidth) - 8; // Round down and adding some margins to account for button borders + extra spacing when total button widths calculation is close to copy wrapper width
    var primaryButtonClone = primaryButtonRef.current.cloneNode(true);
    var secondaryButtonClone = secondaryButtonRef.current.cloneNode(true);

    /**
     * Calculate actual widths of buttons by setting width to auto from 100% of container when stacked
     * Using cloned buttons for calculation removes chance of 'jank' as its not visible when appended and removed from DOM due to style set
     */
    Object.assign(primaryButtonClone.style, {
      width: 'auto',
      position: 'absolute',
      visibility: 'hidden'
    });
    Object.assign(secondaryButtonClone.style, {
      width: 'auto',
      position: 'absolute',
      visibility: 'hidden'
    });
    buttonsContainerRef.current.appendChild(primaryButtonClone);
    buttonsContainerRef.current.appendChild(secondaryButtonClone);

    // Get primary and secondary button widths
    var primaryButtonWidth = primaryButtonClone.offsetWidth;
    var secondaryButtonWidth = secondaryButtonClone.offsetWidth;
    var totalButtonsWidth = Math.ceil(primaryButtonWidth + buttonGap + secondaryButtonWidth); // Round up value so to mitigate edge cases

    buttonsContainerRef === null || buttonsContainerRef === void 0 || buttonsContainerRef.current.removeChild(primaryButtonClone);
    buttonsContainerRef === null || buttonsContainerRef === void 0 || buttonsContainerRef.current.removeChild(secondaryButtonClone);

    // Update button styles to stacked or side by side based on total button widths
    if (totalButtonsWidth >= copyWrapperWidth && !buttonsContainerRef.current.classList.contains('fuse-content-banner-1__buttons--stacked')) {
      buttonsContainerRef.current.classList.add('fuse-content-banner-1__buttons--stacked');
      primaryButtonRef.current.classList.add('fuse-content-banner-1__primary-cta--stacked');
      secondaryButtonRef.current.classList.add('fuse-content-banner-1__secondary-cta--stacked');
    }
    if (totalButtonsWidth < copyWrapperWidth && buttonsContainerRef.current.classList.contains('fuse-content-banner-1__buttons--stacked')) {
      buttonsContainerRef.current.classList.remove('fuse-content-banner-1__buttons--stacked');
      primaryButtonRef.current.classList.remove('fuse-content-banner-1__primary-cta--stacked');
      secondaryButtonRef.current.classList.remove('fuse-content-banner-1__secondary-cta--stacked');
    }
  }, [link.text, secondaryLink.text]);

  /**
   * Add resize event listener (set buttons layout) to window for when user changes orientation or viewport size
   */
  (0, _react.useEffect)(function () {
    if (activePrimaryCTA && activeSecondaryCTA) {
      var handleResize = (0, _debounce["default"])(function () {
        setButtonsLayout();
      }, 200);
      window.addEventListener('resize', handleResize);
      return function () {
        window.removeEventListener('resize', handleResize);
      };
    }
    return function () {};
  }, []);

  /**
   * Using useLayoutEffect to remove 'jank' of button growing to the available space when stacked ie execute effects first before rendering
   */
  (0, _react.useLayoutEffect)(function () {
    if (activePrimaryCTA && activeSecondaryCTA) setButtonsLayout();
  }, [link.text, secondaryLink.text]);
  var wrapApr = function wrapApr(aprText) {
    var aprPattern = /(\d+(\.\d+)?% [Aa][Pp][Rr])/;
    var match = aprText.match(aprPattern);
    if (match) {
      var _match = _slicedToArray(match, 1),
        fullMatch = _match[0];
      var parts = aprText.split(fullMatch);
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, parts[0], /*#__PURE__*/_react["default"].createElement("span", {
        className: "fuse-content-banner-1__wrap-apr"
      }, fullMatch), parts[1]);
    }
    return aprText;
  };
  return /*#__PURE__*/_react["default"].createElement(_styledContentBanner.StyledContentBanner, _extends({
    as: onlyOneCTA && (isPrimaryLink ? 'a' : 'button'),
    href: link.href,
    variant: variant,
    image: image.fallbackSource,
    className: className,
    "data-analyticsid": activePrimaryCTA && !activeSecondaryCTA && dataAnalyticsId,
    "data-testid": dataTestId || 'fuse-content-banner-1-test-id',
    onClick: !link.href && !activeSecondaryCTA ? link.onClick : undefined,
    addBrandColour: addBrandColour,
    lLayout: lLayout,
    smallVariant: smallVariant
  }, props), image.fallbackSource && /*#__PURE__*/_react["default"].createElement(_styledContentBanner.StyledPicture, {
    imageSize: smallVariant ? 'small' : image.size || 'small',
    lLayout: lLayout,
    smallVariant: smallVariant
  }, /*#__PURE__*/_react["default"].createElement(_picture.Picture, _extends({}, image, {
    alt: ""
  }))), /*#__PURE__*/_react["default"].createElement(_styledContentBanner.StyledContent, {
    lLayout: lLayout
  }, /*#__PURE__*/_react["default"].createElement(_styledContentBanner.StyledText, {
    ref: copyWrapperRef
  }, heading && /*#__PURE__*/_react["default"].createElement(_styledContentBanner.StyledHeading, {
    size: {
      xxs: smallVariant ? '2' : '5',
      l: '5'
    },
    tag: headingTag,
    type: "display",
    variant: variant,
    addBrandColour: addBrandColour,
    smallVariant: smallVariant
  }, heading), switchSubHeadingPosition ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, paragraph && ParagraphElement, subHeading && SubHeadingElement) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, subHeading && SubHeadingElement, paragraph && ParagraphElement), representative && /*#__PURE__*/_react["default"].createElement(_styledContentBanner.StyledRepresentative, {
    size: {
      xxs: smallVariant ? '2' : '5',
      l: '5'
    },
    tag: "p",
    type: "display",
    variant: variant,
    addBrandColour: addBrandColour,
    smallVariant: smallVariant
  }, wrapApr(representative)), legalText && /*#__PURE__*/_react["default"].createElement(_styledContentBanner.StyledParagraph, {
    size: {
      xxs: 'm2',
      m: smallVariant ? 'm2' : 'm1',
      l: 'm1'
    },
    tag: "p",
    type: "paragraph",
    variant: variant,
    "data-testid": "fuse-content-banner-1-legal-text-test-id",
    className: "fuse-content-banner-1__legal-text"
  }, legalText)), activePrimaryCTA && /*#__PURE__*/_react["default"].createElement(_styledContentBanner.StyledButtons, {
    lLayout: lLayout,
    ref: buttonsContainerRef
  }, activeSecondaryCTA ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_buttons.Button, {
    className: "fuse-content-banner-1__primary-cta",
    href: link.href,
    icon: /*#__PURE__*/_react["default"].createElement(_ChevronRight["default"], null),
    iconRight: true,
    variant: "tertiary",
    "data-analyticsid": dataAnalyticsId,
    onClick: link.onClick,
    ref: primaryButtonRef,
    size: {
      xxs: smallVariant ? 'small' : 'large',
      l: 'large'
    }
  }, link.text), /*#__PURE__*/_react["default"].createElement(_buttons.Button, {
    className: "fuse-content-banner-1__secondary-cta",
    href: secondaryLink.href,
    icon: /*#__PURE__*/_react["default"].createElement(_ChevronRight["default"], null),
    iconRight: true,
    variant: "tertiary",
    "data-analyticsid": dataAnalyticsIdSecondary,
    onClick: secondaryLink.onClick,
    ref: secondaryButtonRef,
    size: {
      xxs: smallVariant ? 'small' : 'large',
      l: 'large'
    }
  }, secondaryLink.text)) : /*#__PURE__*/_react["default"].createElement(_buttons.SpanButton, {
    className: "fuse-content-banner-1__primary-span-cta",
    icon: /*#__PURE__*/_react["default"].createElement(_ChevronRight["default"], null),
    iconRight: true,
    variant: "tertiary",
    size: {
      xxs: smallVariant ? 'small' : 'large',
      l: 'large'
    }
  }, link.text))));
}
ContentBanner1.propTypes = propTypes;
ContentBanner1.defaultProps = defaultProps;
ContentBanner1.displayName = 'ContentBanner1';
var _default = exports["default"] = ContentBanner1;